<template>

      <w-menu
        ref="zlmenu"
        hide-on-menu-click
        shadow
        color="indigo-dark3"
        grow
        align-left
        :min-width="mwidth"
        @open="showList" 
        @close="closed"
        menu-class="zlookupclass"
        v-model="show"
      >
      <template #activator="{ on }">
          <span class="w-input" v-on="on">
              <z-input
            ref="zlinput"
            v-bind="$attrs" 
            :label="label" 
            :placeholder="placeholder"
            v-model="keyword"
            autocomplete="off"
            @keyup.stop="keydown"
          />
         </span>
      </template>
      <w-list
        ref="zlist"
        v-model="selection"
        :items="filteredItems"
        :multiple="multiple"
        @item-click="choose"
        class="grow mt0"
      >
      </w-list>
    </w-menu>
</template>

<script>

export default {
  name: 'z-select',
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: 'Pilihan'
    },
    placeholder: {
      type: String,
      default: 'Pilih satu...'
    },
    modelValue: {}, 
    items: [Object, Array],
    multiple: {
      type: Boolean,
      default: false,
    },
    sort:  {
      type: Boolean,
      default: false
    },
    cache:  {
      type: Boolean,
      default: false
    },
  },
  emits: ['input', 'update:modelValue'],
  data: () => ({
    selection: 0,
    tmpselection: 0,
    selected: null,
    show: false,
    keyword: '',
    item: [],
    mwidth: 200,
    curitem: -1,
  }),
  mounted() {
    // set the value
    this.selection = this.modelValue
    this.mwidth = this.$refs.zlinput.$el.clientWidth
    // this.item = this.items
    if(this.items.length > 0) {
      if(this.sort)
        this.item = this.items.sort(this.compare)
      else
        this.item = this.items
    }
    this.setvalue();
  },
  methods: {

    setvalue() {
      const sel = this.items.find(x => x.value == this.selection)
      this.keyword = sel ? sel.label : ''
    },
    setoption: function (opts) {
      this.item = opts
    },
    showList() {
      this.show = true
      this.keyword = ''
      this.tmpselection = this.selection
      this.selection = 0
      console.log('open: ' + this.selection + ' - ' + this.tmpselection)
    },
    // choose(e) {
    //   this.selected = e
    //   this.keyword = e.label
    //   this.show = false
    //   // this.$emit('update:modelValue', e.value)
    // },
    choose(e) {
      this.selected = e
      this.selection = e.value  
      this.keyword = e.label
      this.show = false
    },


    closed() {
      // clear value jika pilih item yg sama 2 kali
      if(this.selection!=0 && this.selection == this.tmpselection) {
        this.selection=0;
        this.tmpselection=0;
        this.keyword = '';
      }
      this.selection = this.selection  ? this.selection : this.tmpselection
      this.setvalue()
      this.$emit('update:modelValue', this.selection)
      this.show = false
      console.log('closed: ' + this.selection + ' - ' + this.tmpselection)
      this.$emit('input');
    },
    compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const bandA = a.label.toUpperCase();
      const bandB = b.label.toUpperCase();

      let comparison = 0;
      if (bandA > bandB) {
        comparison = 1;
      } else if (bandA < bandB) {
        comparison = -1;
      }
      return comparison;
    },
    keywordFilter: keyword => item => {
      // Concatenate all the columns into a single string for a faster lookup.
      const allTheColumns = `${item.id} ${item.value} ${item.label}`

      // Lookup the keyword variable in the string with case-insensitive flag.
      return new RegExp(keyword, 'i').test(allTheColumns)
    },
    keydown: function(event) {
      switch (event.keyCode) {
        case 13:
        this.selection = this.$refs.zlist.item[this.curitem].value
        this.closed()
        break;
        case 38:
          if(this.show) {
            this.curitem--
          } else {
            this.show = true
          }
          this.curitem = (this.curitem < 0) ? (this.filteredItems.length-1) : this.curitem
          // console.log(this.curitem + '-' + this.item.length)
          this.$refs.zlist.applySelectionOnItems(this.$refs.zlist.item[this.curitem].value)
          break;
        case 40:
          if(this.show) {
            this.curitem++
          } else {
            this.show = true
          }
          this.curitem = (this.curitem > (this.filteredItems.length-1)) ? 0 : this.curitem
          // console.log(this.curitem + '-' + this.item.length)
          this.$refs.zlist.applySelectionOnItems(this.$refs.zlist.item[this.curitem].value)
          break;
      }
    }
  },
  computed: {
    filteredItems () {
      // fix error kalau text menganduhng karakter ()
      return this.items.filter(i => {
        let text = `${i.id} ${i.value} ${i.label}`;
        return text.toLowerCase().includes(this.keyword.toLowerCase());
      })
    },
  },
    watch: {
    modelValue(val) {
      this.selection = val
      this.setvalue() 
    },
    items() {
      this.setvalue()
    }
  }

}
</script>

<style>
.zlookupclass {
  margin-top: 0px !important;
  z-index: 501;
}

.zlookupclass .w-card__content {
  overflow-y: scroll;
  max-height: 400px;
}
</style>